import { RouteType } from '@/lib/route';
import CourseLibrary from '@/pages/CourseLibrary/index';
import { LibraryQueryInterface } from '@/pages/CourseLibrary/types';

const CourseLibraryRoutes: RouteType = {
  path: '/course-library',
  component: CourseLibrary,
};

export const CourseLibraryDefaultQueryString: LibraryQueryInterface = {
  page: 1,
  search: undefined,
  category: undefined,
};

export default CourseLibraryRoutes;
